import { SelectOptionType } from '@montel/montelpro-shared-components-v2';
import { ProductSettings } from 'domain/product/productMap';
import { SubscribableApplication } from 'domain/subscription/interfaces/SubscribableApplication';
import {
	PermissionAddon,
	SubscriptionPlan,
} from 'domain/subscription/interfaces/Subscription';

export const getApplicationOptions = (
	applications: ProductSettings[] | SubscribableApplication[],
	selectedApplications: string[],
): SelectOptionType[] => {
	const eligible: SelectOptionType[] = [];

	applications.forEach((application) => {
		if (!selectedApplications.includes(application.id)) {
			eligible.push({
				value: application.id,
				label: application.name,
			});
		}
	});

	return eligible;
};

export const getPlanOptions = (
	plans?: SubscriptionPlan[],
): SelectOptionType[] =>
	plans
		? plans.map((plan) => ({
				value: plan.code,
				label: plan.displayName,
		  }))
		: [];

export interface ProviderSelectOptionType extends SelectOptionType {
	addons?: SelectOptionType[];
}

export const getAddonOptions = (
	addons?: PermissionAddon[],
	isSalesRole?: boolean,
): SelectOptionType[] =>
	addons
		? addons.map((addon) => {
				const disabledForSalesRole =
					!!isSalesRole && !addon.accessibleToSalesRole;

				return {
					value: addon.code,
					label: addon.name,
					disabled: disabledForSalesRole,
				};
		  })
		: [];

export const getTypeOptions = (): SelectOptionType[] => [
	{
		value: 'Paid',
		label: 'Paid',
	},
	{
		value: 'Trial',
		label: 'Trial',
	},
	{
		value: 'Free',
		label: 'Free',
	},
	{
		value: 'Internal',
		label: 'Internal',
	},
];
